import type { DataOption } from '@/common.types'

import { map, paths, pick, pipe } from 'lodash/fp'
import { useTranslation } from 'react-i18next'

import { getAnchorsTypesChoices } from '@/entities/anchor'
import { useOptimizationGroupsQuery } from '@/entities/optimization-group'

import { toOption } from '@/shared/tools/utils'

export const useAnchorStrategiesDataChoices = () => {
	const { t } = useTranslation()

	/**
	 * Queries
	 */
	const optimizationGroupsQuery = useOptimizationGroupsQuery<DataOption[]>({
		select: pipe(map(paths(['id', 'name'])), toOption),
	})

	return {
		anchor_type: map(
			pick(['value', 'label']),
			getAnchorsTypesChoices(t)
		) as DataOption[],
		optimization_group_id: optimizationGroupsQuery.data || [],
	}
}
